import React from 'react'; 
import { connect } from 'react-redux';
import { fetchSellers } from '../../actions/sellersActions';


class FiltroSellers extends React.Component {
    constructor (props){
        super(props); 
        this.state = {
            razonSocial: "",
            estado: "",
        }
    };
 
    myChangeHandler = async (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
        this.props.updateText(e.target.value);
    }

    onSubmit = async (event) => {
        event.preventDefault();
        if (this.state.razonSocial != undefined) {
            this.props.fetchSellers(this.state.razonSocial, 10, 1);
        }
    }

    verTodos = () => {
        this.setState({ razonSocial: "" });
        this.props.fetchSellers(this.state.razonSocial, 10, 1);
        this.props.updateText("");
    }

    render() {
        return ( 
            <div className="card card-body filter-card">
                <form 
                    className="row align-items-center justify-content-evenly form-material"
                    onSubmit={this.onSubmit}
                    onReset={this.verTodos} 
                >

                    <div className="col-12 col-sm-3">
                        <label className="label-oscura">Razon social</label>
                        <input 
                            type="text" 
                            name="razonSocial" 
                            value={this.state.razonSocial} 
                            className="form-control" 
                            onChange={this.myChangeHandler} 
                        />
                    </div>

                    <div className="col-12 col-sm-6 text-center text-sm-end mt-sm-3">

                        <button 
                            className="btn btn-sm btn-grey d-inline col-auto mx-2" 
                            type="submit"
                        >
                            Buscar
                        </button>

                        <button 
                            className="btn btn-sm btn-grey d-inline col-auto"
                            type='reset'
                        >
                            Limpiar
                        </button>

                    </div>
                </form>
            </div>
        );
    }
}


const mapStateToProps = state => ({
    sellers: state.sellers.sellers
});

export default connect(mapStateToProps, { fetchSellers }) (FiltroSellers);